import NavigationApartmentsMobile from "../modules/Navigation/apartmentsMobile";

export default class Navigation {
    nav = null;
    navContainer = null;
    subnavButtons = null;
    menuMobileButton = null;

    constructor() {
        this.nav = document.querySelector('.nav');
        this.navContainer = this.nav.querySelector('.nav__data');
        this.subnavButtons = this.nav.querySelectorAll('.nav-list__subnav');
        this.menuMobileButton = document.getElementById('mobileMenuButton');
        this.menuMobileButtonClose = document.getElementById('mobileMenuButtonClose');
        this.navMobileContainer = this.nav.querySelector('.mobile-data');
        this.mobileLanguageButtonClose = document.getElementById('mobileLanguageButtonClose');
        this.mobileApartmentsButtonClose = document.getElementById('mobileApartmentsButtonClose');

        this.bindOnResizeEvent();
        this.bindSubnavButtons();
        this.bindMenuMobileButton();
        this.bindMobileLanguageButton();
        this.bindMobileLanguageCloseButton();
        this.bindApartmentsListTab();
        this.bindMobileApartmentsButton();
        this.bindMobileApartmentsCloseButton();
        this.bindApartmentsCategoriesItemButtons();
        this.turnOffApartmentsCategories();

        this.menuNavigation = new NavigationApartmentsMobile(this.closeApartmentsSection);
    }

    bindOnResizeEvent = () => {
        window.addEventListener('resize', () => {
            if (document.body.clientWidth > 900) {
                document.body.classList.remove('no-overflow');
                this.menuMobileButton.classList.remove('open');
                this.navMobileContainer.classList.remove('open');
            }
        });
    }

    bindSubnavButtons = () => {
        this.subnavButtons.forEach(button => {
            if (document.body.clientWidth > 900) {
                button.addEventListener('mouseover', () => {
                    button.classList.add('active');
                });
    
                button.addEventListener('mouseout', () => {
                    button.classList.remove('active');
                });
            }

            button.addEventListener('click', (e) => {
                if (e.target.parentElement === button) {
                    e.preventDefault();
                }
                if (document.body.clientWidth <= 900) {
                    button.classList.toggle('active');
                }
            });
        });
    }

    bindMenuMobileButton = () => {
        this.menuMobileButton.addEventListener('click', () => {
            this.navMobileContainer.classList.add('open');
            this.menuMobileButton.classList.add('open');
            document.body.classList.add('no-overflow');
        });

        this.menuMobileButtonClose.addEventListener('click', () => {
            this.navMobileContainer.classList.remove('open');
            this.menuMobileButton.classList.remove('open');
            document.body.classList.remove('no-overflow');
        });
    }

    bindMobileLanguageButton = () => {
        const button = document.getElementById('languageSelect');

        if (button) {
            button.addEventListener('click', () => {
                this.navMobileContainer.classList.add('language-container');
            });
        }
    }

    bindMobileLanguageCloseButton = () => {
        if (this.mobileLanguageButtonClose) {
            this.mobileLanguageButtonClose.addEventListener('click', () => {
                this.navMobileContainer.classList.remove('language-container');
            });
        }
    }

    bindMobileApartmentsButton = () => {
        const button = document.getElementById('apartmentsSelect');
        const container = document.querySelector('.list-of-apartments-mobile');

        if (button) {
            button.addEventListener('click', () => {
                this.navMobileContainer.classList.add('apartments-container');
                container.classList.add('active');
            });
        }
    }

    bindMobileApartmentsCloseButton = () => {
        if (this.mobileApartmentsButtonClose) {
            this.mobileApartmentsButtonClose.addEventListener('click', () => {
                this.closeApartmentsSection();
            });
        }
    }

    bindApartmentsCategoriesItemButtons = () => {
        const buttons = document.querySelectorAll('.list-of-apartments-mobile > li');

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                document.querySelector('.list-of-apartments-mobile > li.active')?.classList.remove('active');
                button.classList.toggle('active');
            });
        });
    }

    bindApartmentsListTab = () => {
        const buttons = document.querySelectorAll('.list-of-apartments__left li');

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                document.querySelector(`.list-of-apartments__left li.active`).classList.remove('active');
                button.classList.add('active');

                const id = button.dataset.type;
                document.querySelector(`.list-of-apartments__right .items-list.active`).classList.remove('active');
                document.querySelector(`.list-of-apartments__right .items-list[data-id="${id}"]`).classList.add('active');
            });
        });
    }

    turnOffApartmentsCategories = () => {
        const cards = document.querySelectorAll('.list-of-apartments__right div');

        cards.forEach((card, index) => {
            if (!card.classList.contains('cls')) {
                card.classList.remove('active');
            }
        });
    }

    closeApartmentsSection = () => {
        const container = document.querySelector('.list-of-apartments-mobile');

        this.navMobileContainer.classList.remove('apartments-container');
        container.classList.remove('active');
    }
}